module.exports = __webpack_public_path__ + "static/img/11h.86dd33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11h.jpg
// module id = 9SY2
// module chunks = 1